import React from 'react';
import ViewTabs from '../../common/ViewTabs/ViewTabs';
import { useDispatch, useSelector } from 'react-redux';
import { chessViewMode } from '../../../constants/chessViewMode';
import { setChessViewColorMode } from '../../../store/actions/housingStockActions';
import { Icon, Tooltip } from 'antd';

const viewTabsItems = [
  {
    key: chessViewMode.stages,
    renderIcon: ({ className }) => (
      <Tooltip
        title="Стадии ЖЦ помещений"
        placement="bottomRight"
      >
        <Icon
          type="home"
          className
        />
      </Tooltip>
    ),
  },
  {
    key: chessViewMode.acceptanceStatuses,
    renderIcon: ({ className }) => (
      <Tooltip
        title="Статусы приемки помещений"
        placement="bottomRight"
      >
        <Icon
          type="build"
          className={className}
        />
      </Tooltip>
    ),
  },
  {
    key: chessViewMode.applicationMonitoring,
    renderIcon: ({ className }) => (
      <Tooltip
        title="Мониторинг заявок"
        placement="bottomRight"
      >
        <Icon
          type="download"
          className={className}
        />
      </Tooltip>
    ),
  },
];

const FlatsChessViewTabs = () => {
  const dispatch = useDispatch();

  const chessViewColorMode = useSelector(
    (state) => state.housingStockStore.chessViewColorMode
  );

  const handleChange = (_evt, newValue) => {
    if (newValue !== chessViewColorMode) {
      dispatch(setChessViewColorMode(newValue));
    }
  };

  return (
    <ViewTabs
      value={chessViewColorMode}
      onChange={handleChange}
      items={viewTabsItems}
    />
  );
};

export default FlatsChessViewTabs;
